import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axios";
// utils

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  fetchLoading: false,
  reports: {
    data: [],
    meta: {
      total: 0,
    },
  },
};

// TODO: fetch all the reports
export const fetchReports = createAsyncThunk(
  "fetchReports/reports",
  async ({ enqueueSnackbar, limit=10, page=0, filter, search }, thunkApi) => {
    try {
      const response = await axiosInstance.get(`settings/report`, {
        params: {
          page: page + 1,
          limit,
          ...(filter &&
            filter.status && {
              status: filter.status,
            }),
          ...(search !== "" && {
            search,
          }),
        },
      });

      return {
        data: response.data.data.items,
        meta: {
          total: response.data.data.items.length,
        },
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);


// TODO: delete report
export const deleteReport = createAsyncThunk(
  "deleteReport/reports",
  async ({ enqueueSnackbar, handleClose, id }, thunkApi) => {
    try {
      await axiosInstance.delete(`settings/report/${id}`);
      return {
        data: id,
        handleClose,
        enqueueSnackbar,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

const reportslice = createSlice({
  name: "report",
  initialState,
  extraReducers: (builder) => {
    // TODO: create report
    builder.addCase(fetchReports.pending, (state, _) => {
      state.fetchLoading = true;
    });

    builder.addCase(fetchReports.fulfilled, (state, action) => {
      state.fetchLoading = false;
      state.isLoading = false;
      state.reports = action.payload;
    });

    builder.addCase(fetchReports.rejected, (state, action) => {
      state.isLoading = false;
      state.fetchLoading = false;
      action.payload.enqueueSnackbar(
        JSON.stringify(
          action.payload.error ||
            action.payload.error.errors ||
            action.payload.error.message
        ),
        {
          variant: "error",
        }
      );
    });


    // TODO: delete report
    builder.addCase(deleteReport.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(deleteReport.fulfilled, (state, action) => {
      state.isLoading = false;
      state.reports.data = state.reports.data.filter(
        (report) => report.id !== action.payload.data
      );
      action.payload.enqueueSnackbar("Report is deleted successfully.", {
        variant: "success",
      });
      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(deleteReport.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(
        JSON.stringify(
          action.payload.error ||
            action.payload.error.errors ||
            action.payload.error.message
        ),
        {
          variant: "error",
        }
      );
    });
  },
});

export default reportslice.reducer;
